<template>
  <div>
    <div class="table-responsive full_table mt-0">
      <table class="table caption-top">
        <thead class="bg_table_header">
          <tr>
            <th class="col-md-1 py-3">ID<button class="bt_order_asc bt_order" @click="orderBy(5)"></button><button class="bt_order_desc bt_order" @click="orderBy(-5)"></button></th>
            <th class="col-md-2 py-3">{{ $t('label.especie') }}<button class="bt_order_asc bt_order" @click="orderBy(1)"></button><button class="bt_order_desc bt_order" @click="orderBy(-1)"></button></th>
            <th class="col-md-2 py-3 pl-4">{{ $t('label.estado') }}<button class="bt_order_asc bt_order" @click="orderBy(2)"></button><button class="bt_order_desc bt_order" @click="orderBy(-2)"></button></th>
            <th class="col-md-2 py-3">{{ $t('label.municipio') }}<button class="bt_order_asc bt_order" @click="orderBy(3)"></button><button class="bt_order_desc bt_order" @click="orderBy(-3)"></button></th>
            <th class="col-md-3 py-3">{{ $t('label.areaProtegida') }}<button class="bt_order_asc bt_order" @click="orderBy(4)"></button><button class="bt_order_desc bt_order" @click="orderBy(-4)"></button></th>
            <th class="col-md-2 py-3 pr-4 text-right">{{ $t('label.acoes') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="$store.state.countList === 0"><td colspan="6" class="text-center">{{ $t('message.noRecords') }}</td></tr>
          <tr v-else v-for="item in items" :key="item.place_id">
            <td class="py-3">{{item.place_id}}</td>
            <td class="py-3 pl-4">{{item.specie_scientific_name}}</td>
            <td class="py-3">{{item.state}}</td>
            <td class="py-3">{{item.municipio}}</td>
            <td class="py-3">{{item.protected_area}}</td>
            <td class="py-3">
              <ul class="acoes text-right pr-1">
                <li>
                  <a @click="action($actionEdit, item)" v-if="item.pending_analysis"><span class="nao-validado"></span></a>
                  <template v-else>
                    <a @click="action($actionEdit, item)" v-if="item.by_app"><span class="validado-app"></span></a>
                    <a @click="action($actionEdit, item)" v-else><span class="validar"></span></a>
                  </template>
                </li>
                <li>
                  <a @click="action($actionEdit, item)"><span class="editar"></span></a>
                </li>
                <li>
                  <a @click="action($actionDelete, item)" v-if="$store.state.user && $store.state.user.perfilUser === 'administrator'"><span class="apagar"></span></a>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <TablePagination v-on:searchTable="search()"/>
  </div>
</template>

<script>
import axios from 'axios'
import TablePagination from '@/components/shared/TablePagination'
export default {
  name: 'OcorrenciasTable',
  components: { TablePagination },
  props: {
    items: Array
  },
  data: function () {
    return {
      dataOrderBy: {}
    }
  },
  methods: {
    action: function (action, item) {
      if (action === this.$actionDelete) {
        if (confirm(this.$t('message.confirmDel'))) {
          this.delete(item)
        }
      } else {
        if (this.$route.name === 'AdminHome') {
          this.$store.state.dashboard.currentPage = this.$store.state.currentPage
        }
        this.$router.push({ name: 'AdminOcorrenciasForm', params: { id: item.place_id } })
      }
    },
    delete: function (item) {
      axios.delete(`/DataPlaces/${item.place_id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.search()
        })
    },
    search: function () {
      this.$emit('search')
    },
    orderBy: function (num) {
      if (num === 1) {
        this.$store.state.dataOrderBy.OrderBySpecieScientificNameAcs = true
        this.$store.state.dataOrderBy.OrderBySpecieScientificNameDesc = !this.$store.state.dataOrderBy.OrderBySpecieScientificNameAcs
      }
      if (num === -1) {
        this.$store.state.dataOrderBy.OrderBySpecieScientificNameDesc = true
        this.$store.state.dataOrderBy.OrderBySpecieScientificNameAcs = !this.$store.state.dataOrderBy.OrderBySpecieScientificNameDesc
      }
      if (num === 2) {
        this.$store.state.dataOrderBy.OrderByStateAcs = true
        this.$store.state.dataOrderBy.OrderByStateDesc = !this.$store.state.dataOrderBy.OrderByStateAcs
      }
      if (num === -2) {
        this.$store.state.dataOrderBy.OrderByStateDesc = true
        this.$store.state.dataOrderBy.OrderByStateAcs = !this.$store.state.dataOrderBy.OrderByStateDesc
      }
      if (num === 3) {
        this.$store.state.dataOrderBy.OrderByMunicipioAcs = true
        this.$store.state.dataOrderBy.OrderByMunicipioDesc = !this.$store.state.dataOrderBy.OrderByMunicipioAcs
      }
      if (num === -3) {
        this.$store.state.dataOrderBy.OrderByMunicipioDesc = true
        this.$store.state.dataOrderBy.OrderByMunicipioAcs = !this.$store.state.dataOrderBy.OrderByMunicipioDesc
      }
      if (num === 4) {
        this.$store.state.dataOrderBy.OrderByProtectedAreaAcs = true
        this.$store.state.dataOrderBy.OrderByProtectedAreaDesc = !this.$store.state.dataOrderBy.OrderByProtectedAreaAcs
      }
      if (num === -4) {
        this.$store.state.dataOrderBy.OrderByProtectedAreaDesc = true
        this.$store.state.dataOrderBy.OrderByProtectedAreaAcs = !this.$store.state.dataOrderBy.OrderByProtectedAreaDesc
      }
      if (num === 5) {
        this.$store.state.dataOrderBy.OrderByIDAcs = true
        this.$store.state.dataOrderBy.OrderByIDDesc = !this.$store.state.dataOrderBy.OrderByIDAcs
      }
      if (num === -5) {
        this.$store.state.dataOrderBy.OrderByIDDesc = true
        this.$store.state.dataOrderBy.OrderByIDAcs = !this.$store.state.dataOrderBy.OrderByIDDesc
      }
      this.$emit('orderBy', this.$store.state.dataOrderBy)
    }
  }
}
</script>
